import { ENDPOINTS } from '@environments/endpoints';
import { SUPER_APP_LINKS } from '@environments/super-app-links';
import { SolutionsEnvironment } from '@type/solution';

export const environment = {
  production: false,
  urls: {
    // api: 'http://localhost:3000/',
    api: 'https://dev.api.admin-panel.leafio.cloud/',
    assets: 'assets/',
  },
  endpoints: ENDPOINTS,
  solutions: {
    global: {
      name: 'Global Admin Panel',
      href: 'https://dev.admin-panel.leafio.cloud/',
    },
    super_app: {
      name: 'Leafio Super App',
      downloadAppLinks: SUPER_APP_LINKS,
    },
    inventory: {
      name: 'Leafio Inventory',
      href: 'http://localhost:3033',
    },
    shelf: {
      name: 'Leafio Shelf',
      href: 'https://test.m.leafio-shelf.app/',
    },
    assortment: {
      name: 'Leafio Assortment',
      href: 'https://dev.assortment.leafio.app/',
    },
  } as SolutionsEnvironment,
};
